var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#CDF6F9;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#1A83A8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.959,14.612h-7.572c-0.487,0-0.881-0.395-0.881-0.881v-0.288c0-2.083,1.689-3.772,3.772-3.772h1.789   c2.083,0,3.772,1.689,3.772,3.772v0.288C25.84,14.218,25.446,14.612,24.959,14.612z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 21.173,
    cy: 6.335,
    r: 3.335
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.94,18.25v9.41C8.94,28.4,8.34,29,7.6,29H5.33c-1.07,0-1.94-0.87-1.94-1.94v-8.21   c0-1.07,0.87-1.94,1.94-1.94H7.6C8.34,16.91,8.94,17.51,8.94,18.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M27.95,23.53l-2.51,2.4c-0.74,0.72-1.66,1.21-2.66,1.44l-4.6,1.06c-0.87,0.2-1.78,0.19-2.65-0.03l-6.59-1.66   V19.8l2.09-1.41c1.27-0.87,2.84-1.18,4.35-0.86l4.08,0.85c1,0.21,1.71,1.1,1.71,2.12c0,0.6-0.24,1.14-0.63,1.53   c-0.39,0.39-0.93,0.63-1.53,0.63h1.52c0.42,0,0.83-0.12,1.18-0.35l3.46-2.26c0.87-0.57,2.03-0.43,2.75,0.33l0.1,0.11   C28.83,21.35,28.8,22.71,27.95,23.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.387,15.513h7.572c0.982,0,1.781-0.799,1.781-1.781v-0.288c0-1.809-1.045-3.364-2.552-4.14   c0.753-0.765,1.221-1.812,1.221-2.969c0-2.335-1.9-4.235-4.236-4.235c-2.335,0-4.235,1.9-4.235,4.235   c0,1.156,0.468,2.203,1.22,2.968c-1.508,0.776-2.552,2.331-2.552,4.14v0.288C15.606,14.714,16.405,15.513,17.387,15.513z    M21.173,3.9c1.343,0,2.436,1.092,2.436,2.435s-1.093,2.436-2.436,2.436s-2.435-1.093-2.435-2.436S19.83,3.9,21.173,3.9z    M17.406,13.443c0-1.584,1.288-2.872,2.872-2.872h1.789c1.584,0,2.872,1.288,2.872,2.872v0.269l-7.533,0.02V13.443z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M28.676,19.873l-0.104-0.111c-1.019-1.075-2.656-1.268-3.896-0.461l-2.657,1.732   c0.031-0.175,0.054-0.352,0.054-0.535c0-1.439-1.023-2.699-2.433-2.995l-4.08-0.856c-1.74-0.365-3.576-0.001-5.042,0.996   l-0.692,0.471c-0.071-1.17-1.036-2.104-2.223-2.104H5.335c-1.568,0-2.844,1.276-2.844,2.845v8.202c0,1.568,1.276,2.845,2.844,2.845   h2.269c1.157,0,2.101-0.887,2.214-2.015l5.487,1.385c0.525,0.134,1.068,0.2,1.61,0.2c0.493,0,0.987-0.056,1.468-0.166l4.604-1.057   c1.158-0.266,2.224-0.842,3.08-1.664l2.503-2.404C29.776,23.02,29.822,21.086,28.676,19.873z M8.041,27.663   c0,0.241-0.196,0.437-0.437,0.437H5.335c-0.576,0-1.044-0.468-1.044-1.044v-8.202c0-0.576,0.469-1.044,1.044-1.044h2.269   c0.241,0,0.437,0.195,0.437,0.437V27.663z M27.322,22.882l-2.502,2.403c-0.622,0.598-1.396,1.016-2.236,1.209l-4.604,1.057   c-0.731,0.168-1.503,0.159-2.233-0.025L9.84,26.034V20.28l1.691-1.15c1.064-0.725,2.399-0.985,3.659-0.723l4.081,0.856   c0.58,0.122,1.001,0.641,1.001,1.233c0,0.695-0.564,1.261-1.26,1.261h-2.814c-0.497,0-0.9,0.403-0.9,0.9s0.403,0.9,0.9,0.9h4.333   c0.594,0,1.171-0.172,1.671-0.497l3.456-2.253c0.512-0.333,1.187-0.253,1.602,0.187l0.104,0.111   C27.839,21.607,27.819,22.404,27.322,22.882z"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.c013d2309ece3d35e562c95796a0fb5c.svg";
export { ForwardRef as ReactComponent };